import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
export default function MyEditor({ html, updateRaw }) {
  const contentBlock = htmlToDraft(html);
  const contentState = ContentState.createFromBlockArray(
    contentBlock.contentBlocks
  );
  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(contentState)
  );
  useEffect(() => {
    updateRaw(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  }, [editorState]);
  return (
    <>
      <div
        style={{
          border: "1px solid black",
          padding: "8px",
          minHeight: "400px",
          maxHeight: "600px",
          overflowY: "auto",
          minWidth: "100%",
        }}
        className="prose"
      >
        <Editor
          editorState={editorState}
          onEditorStateChange={setEditorState}
          handlePastedText={() => false}
        />
      </div>
    </>
  );
}
